export default __webpack_public_path__ + "static/LogoL-8e83377b4cc4f4084c78bf1ef47f040f.png";